/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementInfoDto } from './TrackItMeasurementInfoDto';
import {
    TrackItMeasurementInfoDtoFromJSON,
    TrackItMeasurementInfoDtoFromJSONTyped,
    TrackItMeasurementInfoDtoToJSON,
} from './TrackItMeasurementInfoDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfTrackItMeasurementInfoDto
 */
export interface ODataPostProcessedResultsOfTrackItMeasurementInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfTrackItMeasurementInfoDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TrackItMeasurementInfoDto>}
     * @memberof ODataPostProcessedResultsOfTrackItMeasurementInfoDto
     */
    value?: Array<TrackItMeasurementInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfTrackItMeasurementInfoDto
     */
    $type?: ODataPostProcessedResultsOfTrackItMeasurementInfoDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfTrackItMeasurementInfoDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfTrackItMeasurementInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementInfoDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementInfoDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfTrackItMeasurementInfoDtoTypeEnum = typeof ODataPostProcessedResultsOfTrackItMeasurementInfoDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfTrackItMeasurementInfoDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfTrackItMeasurementInfoDto interface.
 */
export function instanceOfODataPostProcessedResultsOfTrackItMeasurementInfoDto(value?: unknown): value is ODataPostProcessedResultsOfTrackItMeasurementInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfTrackItMeasurementInfoDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfTrackItMeasurementInfoDtoFromJSON(json: any): ODataPostProcessedResultsOfTrackItMeasurementInfoDto {
    return ODataPostProcessedResultsOfTrackItMeasurementInfoDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfTrackItMeasurementInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfTrackItMeasurementInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(TrackItMeasurementInfoDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfTrackItMeasurementInfoDtoToJSON(value?: ODataPostProcessedResultsOfTrackItMeasurementInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(TrackItMeasurementInfoDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

